import React from 'react';
interface GroupTherapyIconProps {
  className?: string;
}
export const GroupTherapyIcon: React.FC<GroupTherapyIconProps> = ({
  className
}) => {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-154">
      {/* Center person (larger) */}
      <circle cx="12" cy="8" r="3" data-id="element-155" />
      <path d="M12 14c-3.3 0-6 1.3-6 3v2h12v-2c0-1.7-2.7-3-6-3z" data-id="element-156" />
      {/* Left person */}
      <circle cx="5" cy="9" r="2.5" data-id="element-157" />
      <path d="M5 14c-2 0-3.5.8-3.5 2v1.5h3" data-id="element-158" />
      {/* Right person */}
      <circle cx="19" cy="9" r="2.5" data-id="element-159" />
      <path d="M19 14c2 0 3.5.8 3.5 2v1.5h-3" data-id="element-160" />
    </svg>;
};